var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('main',[_c('Calc')],1),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',[_vm._v("Welcome to Hifz Planner")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',[_vm._v("© 2023 Hifz Planner")])])
}]

export { render, staticRenderFns }